const apiUrl = config.apiUrl;

export const appName = config.appName;
export const appUrl = config.appUrl;
export const appEnv = config.appEnv;
export const useCoachmark = window.global.use_coachmark;
export const languageList = window.global.language_list;
export const languageKeys = Object.keys(languageList);


export const api = {
  signupuser: apiUrl + '/signupuser',
  updateSignupUserProfile: apiUrl + '/signupuser/profile/update',
  createuserlogin: apiUrl + '/createuserlogin',
  login: apiUrl + '/login',
  logout: apiUrl + '/logout',
  currentUser: apiUrl + '/me',
  section: apiUrl + '/section',
  lessons: apiUrl + '/lessons',
  contents: apiUrl + '/lessons/detail',
  updateStatusSection: apiUrl + '/section/status/update',
  updateStatusLesson: apiUrl + '/lessons/status/update',
  updateStatusContent: apiUrl + '/contents/status/update',
  learningLog: apiUrl + '/user/log/learning',
  updateLearningLog: apiUrl + '/user/log/learning/update',
  updateQuestionLog: apiUrl + '/user/log/question/update',
  profile: apiUrl + '/user/profile',
  updateUserProfile: apiUrl + '/user/profile/update',
  updateEmail: apiUrl + '/user/email/update',
  language: apiUrl + '/user/language',
  updateUserLanguage: apiUrl + '/user/language/update',
  progress: apiUrl + '/user/progress',
  updateUserAccount: apiUrl + '/user/account/update',
  updateUserPassword: apiUrl + '/user/password/update',
  newsList: apiUrl + '/newslist',
  unreadnews: apiUrl + '/unreadnews',
  newsMarkAsRead: apiUrl + '/newsmarkasread',
  inquiryList: apiUrl + '/inquiry/list',
  inquiryStore: apiUrl + '/inquiry/store'
};



export const countrieList = [
          { val: 'AF', name: "Afghanistan" },
          { val: 'AL', name: "Albania" },
          { val: 'DZ', name: "Algeria" },
          { val: 'AD', name: "Andorra" },
          { val: 'AO', name: "Angola" },
          { val: 'AG', name: "Antigua and Barbuda" },
          { val: 'AR', name: "Argentina" },
          { val: 'AM', name: "Armenia" },
          { val: 'AU', name: "Australia" },
          { val: 'AT', name: "Austria" },
          { val: 'AZ', name: "Azerbaijan" },
          { val: 'BS', name: "Bahamas" },
          { val: 'BH', name: "Bahrain" },
          { val: 'BD', name: "Bangladesh" },
          { val: 'BB', name: "Barbados" },
          { val: 'BY', name: "Belarus" },
          { val: 'BE', name: "Belgium" },
          { val: 'BZ', name: "Belize" },
          { val: 'BJ', name: "Benin" },
          { val: 'BT', name: "Bhutan" },
          { val: 'BO', name: "Bolivia" },
          { val: 'BA', name: "Bosnia and Herzegovina" },
          { val: 'BW', name: "Botswana" },
          { val: 'BR', name: "Brazil" },
          { val: 'BN', name: "Brunei Darussalam" },
          { val: 'BG', name: "Bulgaria" },
          { val: 'BF', name: "Burkina Faso" },
          { val: 'BI', name: "Burundi" },
          { val: 'CV', name: "Cabo Verde" },
          { val: 'KH', name: "Cambodia" },
          { val: 'CM', name: "Cameroon" },
          { val: 'CA', name: "Canada" },
          { val: 'CF', name: "Central African Republic" },
          { val: 'TD', name: "Chad" },
          { val: 'CL', name: "Chile" },
          { val: 'CN', name: "China" },
          { val: 'CO', name: "Colombia" },
          { val: 'KM', name: "Comoros" },
          { val: 'CG', name: "Congo" },
          { val: 'CK', name: "Cook Islands" },
          { val: 'CR', name: "Costa Rica" },
          { val: 'CI', name: "Cote d'Ivoire" },
          { val: 'HR', name: "Croatia" },
          { val: 'CU', name: "Cuba" },
          { val: 'CY', name: "Cyprus" },
          { val: 'CZ', name: "Czechia" },
          { val: 'CD', name: "Democratic Republic of Congo" },
          { val: 'DK', name: "Denmark" },
          { val: 'DJ', name: "Djibouti" },
          { val: 'DM', name: "Dominica" },
          { val: 'DO', name: "Dominican Republic" },
          { val: 'EC', name: "Ecuador" },
          { val: 'EG', name: "Egypt" },
          { val: 'SV', name: "El Salvador" },
          { val: 'GQ', name: "Equatorial Guinea" },
          { val: 'ER', name: "Eritrea" },
          { val: 'EE', name: "Estonia" },
          { val: 'SZ', name: "Eswatini" },
          { val: 'ET', name: "Ethiopia" },
          { val: 'FJ', name: "Fiji" },
          { val: 'FI', name: "Finland" },
          { val: 'FR', name: "France" },
          { val: 'GA', name: "Gabon" },
          { val: 'GM', name: "Gambia" },
          { val: 'GE', name: "Georgia" },
          { val: 'DE', name: "Germany" },
          { val: 'GH', name: "Ghana" },
          { val: 'GR', name: "Greece" },
          { val: 'GD', name: "Grenada" },
          { val: 'GT', name: "Guatemala" },
          { val: 'GN', name: "Guinea" },
          { val: 'GW', name: "Guinea-Bissau" },
          { val: 'GY', name: "Guyana" },
          { val: 'HT', name: "Haiti" },
          { val: 'VA', name: "Holy See" },
          { val: 'HN', name: "Honduras" },
          { val: 'HU', name: "Hungary" },
          { val: 'IS', name: "Iceland" },
          { val: 'IN', name: "India" },
          { val: 'ID', name: "Indonesia" },
          { val: 'IR', name: "Iran" },
          { val: 'IQ', name: "Iraq" },
          { val: 'IE', name: "Ireland" },
          { val: 'IL', name: "Israel" },
          { val: 'IT', name: "Italy" },
          { val: 'JM', name: "Jamaica" },
          { val: 'JP', name: "Japan" },
          { val: 'JO', name: "Jordan" },
          { val: 'KZ', name: "Kazakhstan" },
          { val: 'KE', name: "Kenya" },
          { val: 'KI', name: "Kiribati" },
          { val: 'KW', name: "Kuwait" },
          { val: 'KG', name: "Kyrgyzstan" },
          { val: 'LA', name: "Lao People's Democratic Republic" },
          { val: 'LV', name: "Latvia" },
          { val: 'LB', name: "Lebanon" },
          { val: 'LS', name: "Lesotho" },
          { val: 'LR', name: "Liberia" },
          { val: 'LY', name: "Libya" },
          { val: 'LI', name: "Liechtenstein" },
          { val: 'LT', name: "Lithuania" },
          { val: 'LU', name: "Luxembourg" },
          { val: 'MG', name: "Madagascar" },
          { val: 'MW', name: "Malawi" },
          { val: 'MY', name: "Malaysia" },
          { val: 'MV', name: "Maldives" },
          { val: 'ML', name: "Mali" },
          { val: 'MT', name: "Malta" },
          { val: 'MH', name: "Marshall Islands" },
          { val: 'MR', name: "Mauritania" },
          { val: 'MU', name: "Mauritius" },
          { val: 'MX', name: "Mexico" },
          { val: 'FM', name: "Micronesia (Federated States of)" },
          { val: 'MC', name: "Monaco" },
          { val: 'MN', name: "Mongolia" },
          { val: 'ME', name: "Montenegro" },
          { val: 'MA', name: "Morocco" },
          { val: 'MZ', name: "Mozambique" },
          { val: 'MM', name: "Myanmar" },
          { val: 'NA', name: "Namibia" },
          { val: 'NR', name: "Nauru" },
          { val: 'NP', name: "Nepal" },
          { val: 'NL', name: "Netherlands" },
          { val: 'NZ', name: "New Zealand" },
          { val: 'NI', name: "Nicaragua" },
          { val: 'NE', name: "Niger" },
          { val: 'NG', name: "Nigeria" },
          { val: 'NU', name: "Niue" },
          { val: 'NO', name: "Norway" },
          { val: 'OM', name: "Oman" },
          { val: 'PK', name: "Pakistan" },
          { val: 'PW', name: "Palau" },
          { val: 'PA', name: "Panama" },
          { val: 'PG', name: "Papua New Guinea" },
          { val: 'PY', name: "Paraguay" },
          { val: 'PE', name: "Peru" },
          { val: 'PH', name: "Philippines" },
          { val: 'PL', name: "Poland" },
          { val: 'PT', name: "Portugal" },
          { val: 'QA', name: "Qatar" },
          { val: 'KR', name: "Republic of Korea" },
          { val: 'MD', name: "Republic of Moldova" },
          { val: 'MK', name: "Republic of North Macedonia" },
          { val: 'RS', name: "Republic of Serbia" },
          { val: 'RO', name: "Romania" },
          { val: 'RU', name: "Russian Federation" },
          { val: 'RW', name: "Rwanda" },
          { val: 'KN', name: "Saint Kitts and Nevis" },
          { val: 'LC', name: "Saint Lucia" },
          { val: 'VC', name: "Saint Vincent and the Grenadines" },
          { val: 'WS', name: "Samoa" },
          { val: 'SM', name: "San Marino" },
          { val: 'ST', name: "Sao Tome and Principe" },
          { val: 'SA', name: "Saudi Arabia" },
          { val: 'SN', name: "Senegal" },
          { val: 'SC', name: "Seychelles" },
          { val: 'SL', name: "Sierra Leone" },
          { val: 'SG', name: "Singapore" },
          { val: 'SK', name: "Slovakia" },
          { val: 'SI', name: "Slovenia" },
          { val: 'SB', name: "Solomon Islands" },
          { val: 'SO', name: "Somalia" },
          { val: 'ZA', name: "South Africa" },
          { val: 'SS', name: "South Sudan" },
          { val: 'ES', name: "Spain" },
          { val: 'LK', name: "Sri Lanka" },
          { val: 'SD', name: "Sudan" },
          { val: 'SR', name: "Suriname" },
          { val: 'SE', name: "Sweden" },
          { val: 'CH', name: "Switzerland" },
          { val: 'SY', name: "Syrian Arab Republic" },
          { val: 'TJ', name: "Tajikistan" },
          { val: 'TH', name: "Thailand" },
          { val: 'TP', name: "Timor-Leste" },
          { val: 'TG', name: "Togo" },
          { val: 'TO', name: "Tonga" },
          { val: 'TT', name: "Trinidad and Tobago" },
          { val: 'TN', name: "Tunisia" },
          { val: 'TR', name: "Turkey" },
          { val: 'TM', name: "Turkmenistan" },
          { val: 'TV', name: "Tuvalu" },
          { val: 'TW', name: "Taiwan" },
          { val: 'UG', name: "Uganda" },
          { val: 'UA', name: "Ukraine" },
          { val: 'AE', name: "United Arab Emirates" },
          { val: 'GB', name: "United Kingdom" },
          { val: 'TZ', name: "United Republic of Tanzania" },
          { val: 'US', name: "United States of America" },
          { val: 'UY', name: "Uruguay" },
          { val: 'UZ', name: "Uzbekistan" },
          { val: 'VU', name: "Vanuatu" },
          { val: 'VE', name: "Venezuela" },
          { val: 'VN', name: "Viet Nam" },
          { val: 'YE', name: "Yemen" },
          { val: 'ZM', name: "Zambia" },
          { val: 'ZW', name: "Zimbabwe" }
        ];

